var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666553 5.53332L4.46655 9.26666C4.73322 9.53332 5.13322 9.53332 5.39989 9.26666C5.66655 8.99999 5.66655 8.59999 5.39989 8.33332L2.13322 4.99999L5.39989 1.66666C5.66655 1.39999 5.66655 0.999992 5.39989 0.733325C5.26655 0.599992 5.13322 0.533325 4.93322 0.533325C4.73322 0.533325 4.59989 0.599992 4.46655 0.733325L0.666553 4.46666C0.399886 4.79999 0.399886 5.19999 0.666553 5.53332C0.666553 5.46666 0.666553 5.46666 0.666553 5.53332Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBtn);
export default __webpack_public_path__ + "static/media/arrow-left-btn.203a41d55aebbd88911fa1643f293619.svg";
export { ForwardRef as ReactComponent };